export var fulfillmentStatuses = {
    FULFILLED: 'Shipped',
    PARTIALLY_FULFILLED: 'Partially Shipped',
    UNFULFILLED: 'Processing'
};
export var financialStatuses = {
    REFUNDED: 'Refunded',
    PARTIALLY_REFUNDED: 'Partially Refunded'
};
/**
 * Convert a Shopify order's status to presentable / human-readable text.
 * @param {String} fulfillmentStatus - Represents the order's aggregated fulfillment status for display purposes.
 * @param {String} financialStatus - Represents the order's current financial status.
 * @param {String} canceledAt - The date and time when the order was canceled. Returns null if the order wasn't canceled.
 * @returns {String} Presentable fulfillment text; empty if unsupported.
 */
export var getOrderStatusLabel = function (fulfillmentStatus, financialStatus, canceledAt) {
    if (financialStatuses[financialStatus])
        return financialStatuses[financialStatus];
    if (canceledAt)
        return 'Canceled';
    if (fulfillmentStatuses[fulfillmentStatus])
        return fulfillmentStatuses[fulfillmentStatus];
    return '';
};
export var links = [
    { name: 'Account Overview', path: '/account' },
    { name: 'Order History', path: '/account/order-history' },
    { name: 'Account Settings', path: '/account/settings' }
];
export var linksV2 = [
    {
        name: 'Account Details',
        path: '/account/settings/details',
        description: 'Update your information, including name and password.'
    },
    {
        name: 'Saved Addresses',
        path: '/account/settings/addresses',
        description: 'Add or edit addresses you’ve shipped to orders to.'
    }
];
export var linksWithHashedEmail = [
    {
        name: 'Communication Preferences',
        path: '/account/settings/preferences',
        description: 'Choose how you want to be contacted and customize your preferences.'
    }
];
/**
 * Converts a Shopify namespaced Global ID to an Order ID.
 * @param {String} globalId Namespaced Global ID
 * @returns {String} Order ID
 */
export var convertGlobalIdToOrderId = function (globalId) {
    return globalId.substr(globalId.lastIndexOf('/') + 1);
};
/**
 * Converts a Shopify Order ID with a key to a namespaced global ID.
 * @param {Number|String} orderId Order ID
 * @returns {String} Namespaced Global ID
 */
export var convertOrderIdToGlobalId = function (orderId) {
    return "gid://shopify/Order/".concat(orderId);
};
/**
 * Formats an order name based on the presence of the 'EXC' prefix.
 * If an order name contains the prefix, we exclude the number symbol from the name.
 */
export var formatOrderName = function (name) {
    return (name === null || name === void 0 ? void 0 : name.includes('EXC')) ? name : "#".concat(name === null || name === void 0 ? void 0 : name.replace(/#/g, ''));
};
/**
 * Checks if a given date is more than a specified number of months old.
 *
 * @param {string} dateString - The date to check in string format (e.g., "2023-08-11T16:34:36Z").
 * @param {number} months - The number of months to compare against.
 * @returns {boolean} True if the date is more than the specified number of months old, otherwise false.
 */
export var isDateMoreThanMonthsOld = function (dateString, months) {
    // Convert the dateString to a Date object
    var inputDate = new Date(dateString);
    // Get the current date
    var currentDate = new Date();
    // Calculate the difference in milliseconds
    var timeDifference = currentDate.getTime() - inputDate.getTime();
    // Calculate the number of months
    var monthsDifference = timeDifference / (1000 * 3600 * 24 * 30.44); // Approximate average month length
    // Check if the difference is greater than the specified number of months
    return monthsDifference > months;
};
export default {};
